<div class="unselectable headerToolbar">

  <div style="margin-left: 10px">{{ (!!gridsterItem.name) ? gridsterItem.name : widgetTitle }}</div>

  <span style="flex: 1 1"></span>


  <div #headerButtons class="headerButtons" [style.opacity]="isOverflown(headerButtons)? 0 : 1">
    <ng-container *ngIf="(buttons !== undefined && buttons.length)">
      <ng-container *ngFor="let button of buttons; let i = index">
        <dx-button (click)="button.clickable && !!button.callbackFn() ? button.callbackFn() : doNothing()"
                   *ngIf="!(button.editOnly && !editMode)"
                   [hidden]="!button.visible"
                   [disabled]="isOverflown(headerButtons)"
                   [stylingMode]="'text'" [title]="button.label"
                   class="gridster-item-content">
          <i class="vr-ic_fluent_{{button.icon}}_24_regular headerMiniIcons"></i>
        </dx-button>
      </ng-container>
    </ng-container>
    <div *ngIf="editMode" class="border-right-separator"></div>
    <dx-button
      (click)="removeWidget.emit($event)"
      *ngIf="editMode"
      [hidden]="hideEdit"
      [stylingMode]="'text'"
      [disabled]="isOverflown(headerButtons)"
      class="gridster-item-content">
      <i class="vr-ic_fluent_delete_24_regular"></i>
    </dx-button>
  </div>

  <dx-menu
    *ngIf="isOverflown(headerButtons)"
    [height]="32"
    [hideSubmenuOnMouseLeave]="false"
    [width]="34"
    (onSubmenuHidden)="onSubMenuHidden($event)"
    (onSubmenuShown)="onSubMenuShown($event)">
    <dxi-item [closeMenuOnClick]="true" [cssClass]="'topbarMenu'" [height]="32" [width]="34">
      <div *dxTemplate style="padding: 5px; width: 34px; height: 32px;">
        <i class="vr-ic_fluent_more_vertical_48_regular"></i>
      </div>
      <dxi-item>
        <div *dxTemplate class="no-hover headerButtons">
          <ng-container *ngIf="(buttons !== undefined && buttons.length)">
            <ng-container *ngFor="let button of buttons; let i = index">
              <dx-button (click)="button.clickable && !!button.callbackFn() ? button.callbackFn() : doNothing()"
                         *ngIf="!(button.editOnly && !editMode)"
                         [hidden]="!button.visible"
                         [stylingMode]="'text'" [title]="button.label"
                         class="gridster-item-content">
                <i class="vr-ic_fluent_{{button.icon}}_24_regular headerMiniIcons"></i>
              </dx-button>
            </ng-container>
            <div *ngIf="editMode" class="border-right-separator"></div>
            <dx-button
              (click)="removeWidget.emit($event)"
              *ngIf="editMode"
              [hidden]="hideEdit"
              [stylingMode]="'text'"
              class="gridster-item-content">
              <i class="vr-ic_fluent_delete_24_regular"></i>
            </dx-button>
          </ng-container>
        </div>
      </dxi-item>
    </dxi-item>
  </dx-menu>

</div>
